import React from 'react';
import './speach.css';

function Speach() {
  return (
    <div className='speach'>    
      <div className="speach-header">
        <h6>Why we exist</h6>
      </div>
      <div className="speach-content">
        <div className="quote">
          <h6>
            We founded Penny with a simple thesis. We believe that there is a win-win situation between grocery stores and consumers that is not being fully communicated. By leveraging AI, we saw a vision where we could help grocery stores and consumers to save time and money, all while minimizing waste.
            <br/><br/>
            In 2025, we began collaborating with the biggest grocery stores in the Nordics. Through shared efforts, mutual growth, and true problem-solving, we engineered a product tailored to handle the win-win situation for both grocery stores and consumers.
            <br/><br/>
            The spirit at Penny is clear. Our team of product builders and engineers ship fast and innovate—with our users and clients. However, our collaborative approach goes further.
            <br/><br/>
            We are building Penny to unlock unparalleled collaboration between grocery stores and consumers, enabling them to take advantage of the AI to save time and money, all while minimizing waste. {/*While keeping the main functionality available for everyone for free use, we offer a premium version for users to take advantage of the AI to optimize their grocery shopping experience.*/}
            <br/><br/>
            Penny's mission is to empower sustainability for both grocery stores and consumers. We can make this a reality through building a collaborative platform for grocery stores and consumers. By changing the way we consume with easy AI-powered applications, we can make a difference.
          </h6>
          </div>
          <div className="credentials">
            <h6>Marco Sagredo and Sofia Hagberg</h6>
            <h6>Co-founders, Penny</h6>
          </div>
      </div>
    </div>
  );
}

export default Speach;